module.exports = __webpack_public_path__ + "img/de-DE-add-to-google-wallet.b168e79.svg";